import { useState } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";
import { InfoPage } from "./Info";
import { Button, Form } from "react-bootstrap";
import IconPicker from '../../components/IconPicker';
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js';

export async function InfoLoader({ params }: any): Promise<Event | undefined> {
	const infoPageId = params.infoPageId;
	console.log(infoPageId);

	const res = await fetch(`${process.env.REACT_APP_API_URL}/info`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	});

	const data = await res.json();

	if (!res.ok) {
		console.error(data.message);
		throw new Error(data.message);
	}

	for (const infoPage of data) {
		if (infoPage.id === infoPageId) {
			return infoPage;
		}
	}
}

function convertIconToPickerFormat(icon: string) {
	return "Md" + icon.replace(/[a-z]/, v => v.toLocaleUpperCase()).replaceAll(/-([a-z])/g, v => v[1].toUpperCase());
}

export default function InfoEdit() {
	const navigation = useNavigate();
	const infoPage: InfoPage = useLoaderData() as InfoPage;

	console.log(infoPage.icon);
	console.log(convertIconToPickerFormat(infoPage.icon));

	const [title, setTitle] = useState(infoPage.title);
	const [pageType, setPageType] = useState(infoPage.pageType);
	const [content, setContent] = useState(infoPage.content);
	const [icon, setIcon] = useState(convertIconToPickerFormat(infoPage.icon));
	const iconName = icon.substring(1).replace(/([A-Z])/, v => v.toLocaleLowerCase()).replaceAll(/([A-Z])/g, v => `-${v.toLowerCase()}`).substring(1);

	function formSubmit(e: React.FormEvent<HTMLFormElement>) {
		e.preventDefault();
		onSubmit();
	}

	async function onSubmit() {
		const json = {
			title,
			pageType,
			content,
			icon: iconName,
		};
		const res = await fetch(`${process.env.REACT_APP_API_URL}/info/${infoPage.id}`, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(json),
		});
		const data = await res.json();
		console.log(data);

		if (res.ok) {
			navigation('/info');
		}
	}

	return (
		<div className="InfoNew">
			<div className='container container-lg'>
				<Form onSubmit={formSubmit}>
					<Form.Group controlId="title" className="mb-3">
						<Form.Label>Title</Form.Label>
						<Form.Control type="text" placeholder="Enter title" value={title} onChange={e => setTitle(e.target.value)} />
					</Form.Group>
					<Form.Group controlId="icon" className="mb-3">
						<Form.Label>Icon</Form.Label>
						{ /* @ts-ignore */}
						<IconPicker
							value={icon}
							onChange={(v: string) => setIcon(v)}
						/>
					</Form.Group>
					<Form.Group controlId="pageType" className="mb-3">
						<Form.Label>Page Type</Form.Label>
						<Form.Select value={pageType} onChange={e => setPageType(e.target.value as "link" | "text")}>
							<option value="text">Text</option>
							<option value="link">Link</option>
						</Form.Select>
					</Form.Group>
					{pageType === "text" && <TextContent setContent={setContent} initialContent={infoPage.content} />}
					{pageType === "link" && <LinkContent setContent={setContent} content={content} />}
					<Button variant="primary" type="submit">
						Save
					</Button>
				</Form>
			</div>
		</div>
	);
}

function TextContent({ setContent, initialContent }: { initialContent: any, setContent: (content: any) => void }) {

	const [editorState, setEditorState] = useState<EditorState>(EditorState.createWithContent(convertFromRaw(initialContent)));

	function onEditorStateChange(editorState: EditorState) {
		setEditorState(editorState);
		setContent(convertToRaw(editorState.getCurrentContent()));
	}

	return (
		<Form.Group controlId="content" className="mb-3">
			<Form.Label>Content</Form.Label>
			<Form.Control as={Editor}
				editorState={editorState}
				toolbarClassName="toolbarClassName"
				wrapperClassName="wrapperClassName"
				editorClassName="editorClassName"
				onEditorStateChange={onEditorStateChange}
				wrapperStyle={{ border: "1px solid black", borderRadius: 5, padding: "5px" }}
			/>
		</Form.Group>
	);
}

function LinkContent({ content, setContent }: { content: { href: string }, setContent: (content: { href: string }) => void }) {
	return (
		<Form.Group controlId="content" className="mb-3">
			<Form.Label>Link</Form.Label>
			<Form.Control type="text" placeholder="Enter Link" value={content.href} onChange={e => setContent({ href: e.target.value })} />
		</Form.Group>
	);
}
